export default "__VITE_ASSET__BVJCkbzh__"